// Helper do FAQPage JSON-LD (schema.org). Wstrzykiwany w `head().scripts`
// na landingach SEO — daje rich snippet FAQ w SERP Google.
//
// Zwraca `null` jeśli po normalizacji nie ma wystarczająco długich par Q/A,
// żeby nie emitować pustego/niepoprawnego schema (Google to penalizuje).

interface FaqEntry {
  q?: string | null;
  a?: string | null;
}

const stripHtml = (s: string) =>
  s.replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();

const normalizeQuestion = (s: string) => {
  const t = stripHtml(s);
  if (!t) return t;
  return t.endsWith("?") || t.endsWith(".") ? t : `${t}?`;
};

export function faqScript(items: FaqEntry[]): {
  type: "application/ld+json";
  children: string;
} | null {
  const cleaned = items
    .map((f) => ({
      q: normalizeQuestion(f.q ?? ""),
      a: stripHtml(f.a ?? ""),
    }))
    .filter((f) => f.q.length > 3 && f.a.length > 10);

  // Dedup po znormalizowanym pytaniu (case-insensitive).
  const dedup = new Map<string, { q: string; a: string }>();
  for (const f of cleaned) {
    const key = f.q.toLowerCase();
    if (!dedup.has(key)) dedup.set(key, f);
  }
  const final = Array.from(dedup.values());
  if (final.length === 0) return null;

  return {
    type: "application/ld+json",
    children: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: final.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    }),
  };
}
